<section class="feature-section-alt">

    <div class="container-redesign">

        <div class="feature-section-alt__wrapper">

            <div class="feature-section-alt__content">

                <h2 class="feature-section-alt__title">
                    Meet <span>AltheaCare</span>
                </h2>

                <p class="feature-section-alt__description">
                    AltheaCare is an AI-powered mental health monitoring platform that continuously
                    analyzes patient data, detects early risk patterns, and alerts care teams in
                    real time — before critical events escalate.
                </p>

                <p class="feature-section-alt__description">
                    It is designed for institutional mental healthcare settings, where reliability,
                    clinical coordination, compliance, and clarity matter.
                </p>

                <div class="feature-section-alt__list">

                    <div
                        class="feature-section-alt__item"
                        *ngFor="let feature of features; trackBy: trackByText">

                        <div class="feature-section-alt__check">

                            <img
                                src="/assets/img/redesign/check.svg"
                                alt="">

                        </div>

                        <span>{{ feature.text }}</span>

                    </div>

                </div>

                <a
                    routerLink="/contact-redesign"
                    class="feature-section-alt__button">

                    <span>TALK TO OUR TEAM</span>

                    <img
                        src="/assets/img/redesign/flecha.svg"
                        alt=""
                        class="feature-section-alt__button-icon">

                </a>

            </div>

            <div class="feature-section-alt__image">

                <img
                    src="/assets/img/redesign/product06.jpg"
                    alt="AltheaCare">

            </div>

        </div>

    </div>

</section>